
import { useState, useEffect } from 'react';
import { AdminModuleList } from '@/components/admin/AdminModuleList';
import { ContentSeeder } from '@/components/admin/ContentSeeder';
import { PageLayout } from '@/components/layout/PageLayout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { SetAdminStatus } from '@/components/admin/SetAdminStatus';
import { setUserAdminStatus } from '@/utils/auth-utils';
import { toast } from '@/hooks/use-toast';

export default function AdminModules() {
  const [activeTab, setActiveTab] = useState('modules');

  // This effect will run on component mount to make nate@nubox.com an admin automatically
  useEffect(() => {
    const makeNateAdmin = async () => {
      try {
        await setUserAdminStatus('nate@nubox.com');
        console.log('Made nate@nubox.com an admin');
      } catch (error) {
        console.error('Error making nate@nubox.com an admin:', error);
      }
    };
    
    makeNateAdmin();
  }, []);

  return (
    <PageLayout
      title="Admin Dashboard"
      subtitle="Manage learning modules and content"
    >
      <Tabs defaultValue={activeTab} onValueChange={setActiveTab} className="w-full max-w-4xl mx-auto">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="modules">Modules</TabsTrigger>
          <TabsTrigger value="seed">Seed Content</TabsTrigger>
          <TabsTrigger value="admin">User Admin</TabsTrigger>
        </TabsList>
        <TabsContent value="modules">
          <AdminModuleList />
        </TabsContent>
        <TabsContent value="seed">
          <ContentSeeder />
        </TabsContent>
        <TabsContent value="admin">
          <SetAdminStatus />
        </TabsContent>
      </Tabs>
    </PageLayout>
  );
}
